function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12.9451 5.48279H7.00019C6.0513 5.48279 5.2793 6.2804 5.2793 7.26077V13.4029C5.2793 14.3833 6.0513 15.1811 7.00019 15.1811H12.9451C13.894 15.1811 14.6662 14.3835 14.6662 13.4029V7.26077C14.6662 6.2804 13.8942 5.48279 12.9451 5.48279ZM9.97263 13.5246C8.26885 13.5246 6.88263 12.0924 6.88263 10.3318C6.88263 8.57153 8.26885 7.13932 9.97263 7.13932C11.6766 7.13932 13.0629 8.57153 13.0629 10.3318C13.0629 12.0921 11.6764 13.5246 9.97263 13.5246ZM12.4309 7.04404C12.4309 7.46052 12.7589 7.79941 13.1622 7.79941C13.5653 7.79941 13.8933 7.46052 13.8933 7.04404C13.8933 6.62755 13.5653 6.28867 13.1622 6.28867C12.7589 6.28867 12.4309 6.62755 12.4309 7.04404Z",
  fill: "#BAA273"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M9.97292 8.4884C8.98937 8.4884 8.18848 9.31541 8.18848 10.3316C8.18848 11.3482 8.98937 12.1755 9.97292 12.1755C10.9569 12.1755 11.7571 11.3482 11.7571 10.3316C11.7571 9.31563 10.9567 8.4884 9.97292 8.4884Z",
  fill: "#BAA273"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M0 10.304C0 4.61349 4.46533 0 9.97311 0C15.4809 0 19.9462 4.61349 19.9462 10.304C19.9462 15.9945 15.4809 20.608 9.97311 20.608C4.46533 20.608 0 15.9945 0 10.304ZM12.9456 16.5299C14.6147 16.5299 15.9722 15.1273 15.9722 13.4029V7.26072C15.9722 5.53646 14.6147 4.13364 12.9456 4.13364H7.00067C5.33178 4.13364 3.974 5.53646 3.974 7.26072V13.4029C3.974 15.1273 5.33178 16.5299 7.00067 16.5299H12.9456Z",
  fill: "#BAA273"
});

var SvgInstagram = function SvgInstagram(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgInstagram, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/instagram.c24af0d4.svg";
export { ForwardRef as ReactComponent };